export default [
    {
        path: '/company/settings',
        name: 'CompanySettings',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/company/CompanySettings.vue'),
        },
    },
];
